module.exports = __webpack_public_path__ + "img/banner1@2x.2a4b2a6c.png";